// Global Instructions Rule Applied!

import {
  SetFilterOptionsAction,
  SetFundsAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  ClearActiveSortingAction,
  UpdateFundRecordAction,
  AddFundAction,
  AppendFundsAction,
  FundsPaginatedResponse,
  FilterValue,
  SortConfig
} from '../../interfaces/funds.ts'
import { FundRecord } from '../../data_models/fund_record.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import {
  SET_FILTER_OPTIONS,
  SET_FUNDS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  CLEAR_ACTIVE_SORTING,
  UPDATE_FUND_RECORD,
  ADD_FUND,
  APPEND_FUNDS
} from './constants.ts'

export const setFilterOptions = ({ response }: { response: TableFilterOptionsResponse }): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response }
})

export const setFunds = ({ response }: { response: FundsPaginatedResponse }): SetFundsAction => ({
  type: SET_FUNDS,
  payload: { response }
})

export const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

export const setActiveSorting = ({ sorting }: { sorting: SortConfig[] }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

export const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const clearActiveSorting = (): ClearActiveSortingAction => ({
  type: CLEAR_ACTIVE_SORTING,
  payload: {}
})

export const updateFundRecord = ({
  fundId,
  updates
}: {
  fundId: string
  updates: Record<string, any>
}): UpdateFundRecordAction => ({
  type: UPDATE_FUND_RECORD,
  payload: { fundId, updates }
})

export const addFund = ({ fund }: { fund: FundRecord }): AddFundAction => ({
  type: ADD_FUND,
  payload: { fund }
})

export const appendFunds = ({ response }: { response: FundsPaginatedResponse }): AppendFundsAction => ({
  type: APPEND_FUNDS,
  payload: { response }
})
